<script>
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import AppInputDouble from '@/components(new)/UI/Forms/InputDouble/InputDouble'
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import TitleWithRow from '@/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue'
import * as options from '@/libs/constants/praticas/opcoesSelects'
import Bioinsumos from '@/components(new)/UI/Forms/FormulariosProntos/Bioinsumos/Bioinsumos.vue'

export default {
  mixins: [onlyInputNumbers],
  components: {
    Label,
    AppInputDouble,
    InputSelect,
    TitleWithRow,
    Bioinsumos
  },
  props: {
    pratica: {
      type: Object,
      required: true
    },
    nomeAba: {
      type: String,
      required: true
    },
    // validação dos campos para as práticas SPDG e SPDH
    praticasArray: {
      typeof: Array,
      require: false,
      default: null
    }
  },
  data () {
    return {
      options
    }
  },
  computed: {
    rules () {
      return !this.praticasArray ? 'required' : !this.praticasArray.length ? 'required' : ''
    },
    rulesArea () {
      return !this.praticasArray ? 'area' : !this.praticasArray.length ? 'area' : ''
    }
  },
  methods: {
    containsOption (value, option, model) {
      let contains
      if (!Array.isArray(value)) {
        contains = value === option
      } else {
        contains = value.includes(option)
      }
      if (!contains) {
        const props = model.split('.')
        const lastProp = props.pop()
        const target = props.reduce((acc, curr) => acc?.[curr], this.pratica)
        if (target && lastProp) {
          target[lastProp] = null
        }
      }
      return contains
    }
  }
}
</script>

<template>
  <div>
    <TitleWithRow title="Irrigação" />
    <el-row :gutter="20">
      <InputSelect
        label="Possui sistemas irrigados ou sistema fertirrigação?"
        v-model="pratica.possuiIrrigacao"
        :nomeAba="nomeAba"
        :opcoes="options.opcoesSimNao"
        :widthColumn="10"
        obrigatorio
        :rulesInput="rules"
      />
      <validation-provider
        :rules="rulesArea"
        v-slot="{ errors }"
        mode="lazy"
        :name="`${nomeAba}/Área irrigada`"
        v-if="containsOption(pratica.possuiIrrigacao, true, 'irrigacao.area')"
      >
        <el-col :span="8">
          <Label label="Área irrigada (ha)" obrigatorio />
          <AppInputDouble
            name="Área"
            v-model="pratica.irrigacao.area"
            :precision="2"
            :onkeypress="onlyInputNumbers"
            showAppend
            :class="{ 'input erro': errors.length }"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>

      <validation-provider
        :rules="rules"
        v-slot="{ errors }"
        mode="lazy"
        :name="`${nomeAba}/Data início da irrigação`"
        v-if="
          containsOption(pratica.possuiIrrigacao, true, 'irrigacao.dataInicio')
        "
      >
        <el-col :span="6">
          <Label label="Data de início da irrigação" obrigatorio />
          <el-date-picker
            v-model="pratica.irrigacao.dataInicio"
            type="month"
            placeholder="Selecione mês e ano"
            format="MM/yyyy"
            value-format="yyyy-MM-dd"
            style="width: 100%;"
            :class="{'input erro' : errors.length}"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
    </el-row>

    <el-row :gutter="20">
      <InputSelect
        v-if="containsOption(pratica.possuiIrrigacao, true, 'irrigacao.tiposSistemas')"
        multiSelect
        label="Tipo(s) de sistema(s)"
        v-model="pratica.irrigacao.tiposSistemas"
        :opcoes="options.opcoesTipoSistemaIrrigacao"
        :nomeAba="nomeAba"
        :widthColumn="5"
        obrigatorio
        :rulesInput="rules"
      />

      <validation-provider
        v-if="
          containsOption(
            pratica.irrigacao.tiposSistemas,
            'OUTRO',
            'irrigacao.outroSistema'
          )
        "
        :rules="rules"
        v-slot="{ errors }"
        mode="lazy"
        :name="`${nomeAba}/Outros tipos de sistema de irrigação`"
      >
        <el-col :span="8">
          <Label label="Outros tipos de sistema de irrigação:" obrigatorio />
          <el-input
            name="Outros tipos de sistema de irrigação"
            v-model="pratica.irrigacao.outroSistema"
            :class="{ 'input erro': errors.length }"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>

      <InputSelect
        v-if="containsOption(pratica.possuiIrrigacao, true, 'irrigacao.fontesAgua')"
        label="Fonte de água utilizada"
        v-model="pratica.irrigacao.fontesAgua"
        :nomeAba="nomeAba"
        :opcoes="options.opcoesFonteAguaUtilizada"
        :widthColumn="8"
        obrigatorio
        multiSelect
        :rulesInput="rules"
      />

      <validation-provider
        v-if="
          containsOption(
            pratica.irrigacao.fontesAgua,
            'OUTRO',
            'irrigacao.outroFonteAgua'
          )
        "
        :rules="rules"
        v-slot="{ errors }"
        mode="lazy"
        :name="`${nomeAba}/Outros tipos de fonte de água utilizada`"
      >
        <el-col :span="8">
          <Label label="Outros tipos de fonte de água utilizada:" obrigatorio />
          <el-input
            name="Outros tipos de fonte de água utilizada:"
            v-model="pratica.irrigacao.outroFonteAgua"
            :class="{ 'input erro': errors.length }"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
    </el-row>

    <el-row :gutter="20">
      <InputSelect
        v-if="containsOption(pratica.possuiIrrigacao, true, 'irrigacao.captacaoLicenciada')"
        label="Captação licenciada?"
        v-model="pratica.irrigacao.captacaoLicenciada"
        :opcoes="options.opcoesCaptacaoLicenciada"
        :nomeAba="nomeAba"
        :widthColumn="8"
        obrigatorio
        :rulesInput="rules"
      />

      <el-col
        :span="12"
        v-if="
          containsOption(
            pratica.possuiIrrigacao,
            true,
            'irrigacao.quantidadeAguaAnual'
          )
        "
      >
        <Label label="Qual a quantidade de água anual utilizada?" />
        <AppInputDouble
          name="Qual a quantidade de água anual utilizada?"
          v-model="pratica.irrigacao.quantidadeAguaAnual"
          :precision="2"
          :onkeypress="onlyInputNumbers"
          :appendText="'m³'"
          showAppend
        />
      </el-col>
    </el-row>
  </div>
</template>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/FormulariosProntos/Irrigacao/Irrigacao.vue